import { t } from '@ankr.com/common';
import { ChainID } from '@ankr.com/chains-list';

import {
  TAC_TESTNET_SPB_EVM_PATH,
  TAC_TESTNET_SPB_TENDERMINT_RPC_PATH,
  TAC_TESTNET_TURIN_EVM_PATH,
  TAC_TESTNET_TURIN_TENDERMINT_RPC_PATH,
} from 'modules/chains/constants';

import { root } from '../../../const';

const evmTestnets = [TAC_TESTNET_SPB_EVM_PATH, TAC_TESTNET_TURIN_EVM_PATH];

const tendermintTestnets = [
  TAC_TESTNET_SPB_TENDERMINT_RPC_PATH,
  TAC_TESTNET_TURIN_TENDERMINT_RPC_PATH,
];

export const renderTacTitle = (url: string) => {
  const path = new URL(url).pathname
    .split('/')
    .filter(pathItem => !!pathItem)[0];

  if (evmTestnets.includes(path as ChainID)) {
    return t(`${root}.endpoints.evm-wss-title`);
  }

  if (tendermintTestnets.includes(path as ChainID)) {
    return t(`${root}.endpoints.tendermint-wss-title`);
  }

  return undefined;
};
